import Reveal from '@/components/feature/Reveal';
import { SectionWrapper, SectionHeading } from '@/components/feature/SectionHeading';

export default function Message() {
  return (
    <SectionWrapper>
      <SectionHeading eyebrow="Message" title="代表挨拶" align="left" />

      <div className="mt-12 md:mt-16 grid grid-cols-1 md:grid-cols-2 gap-10 md:gap-16 items-center">
        <Reveal>
          <div className="relative rounded-2xl overflow-hidden border border-[#2a2a3e] aspect-square">
            <img
              src="https://media.genaiweb.ai/1cfcb9a7-5410-444f-8143-602b7e61a697/ceo-greeting-portrait.jpg"
              alt="株式会社ルヴィラ 代表取締役"
              title="株式会社ルヴィラ 代表取締役"
              className="w-full h-full object-cover object-center"
            />
            <div className="absolute inset-0 bg-gradient-to-t from-[#0d0d1a]/60 via-transparent to-transparent"></div>
            <div className="absolute bottom-5 left-5">
              <p className="text-sm font-semibold text-white">代表取締役</p>
              <p className="text-xs text-white/80">株式会社ルヴィラ</p>
            </div>
          </div>
        </Reveal>

        <Reveal delay={120}>
          <div className="space-y-5">
            <p className="text-base md:text-lg text-[#e8e8f0] leading-loose">
              私たちルヴィラは、AIを導入し、運用し、成果を出し続ける会社です。会社の成長を妨げている業務・情報・判断の滞りを見つけ、AIの力で解消することを使命としています。
            </p>
            <p className="text-sm md:text-base text-[#a0a0b0] leading-loose">
              会社の成長を止めるのは、新しい技術の不足ではありません。経営者に集中する判断、分散した情報、見えにくい業務の流れ。こうした小さな滞りが、組織の動きを遅くしています。
            </p>
            <p className="text-sm md:text-base text-[#a0a0b0] leading-loose">
              私たちは、経営者の時間を次の成長に使い、現場が動きやすくなる仕組みづくりを、AIを活用して支えていきます。AIに詳しくない経営者の方にも分かりやすく、誠実に、これからも寄り添ってまいります。
            </p>
            <p className="pt-4 text-sm text-[#e8e8f0]">代表取締役　成相 政和</p>
          </div>
        </Reveal>
      </div>
    </SectionWrapper>
  );
}